module.exports = __webpack_public_path__ + "static/img/rank_296.31200f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_296.png
// module id = 33m5
// module chunks = 1